import { ModalLayout } from '@components/Layouts'
import { getTrackingConfig, TrackingInsights } from '@components/Tracking'
import { useNavigation } from '@react-navigation/native'
import { useTrackingEventsStore } from '@stores/trackingEvents'
import { useEffect } from 'react'
import styled from 'styled-components/native'

const Wrapper = styled.View`
  padding: 0 20px;
`

export function TrackingInsightsModal() {
  const navigation = useNavigation()
  const [trackingType] = useTrackingEventsStore((state) => [state.selectedTrackingType])

  const trackingConfig = trackingType && getTrackingConfig(trackingType)

  useEffect(() => {
    if (!trackingConfig) {
      navigation.goBack()
    }
  }, [trackingConfig])

  if (!trackingConfig) return null

  return (
    <ModalLayout title={trackingConfig.title}>
      <Wrapper>
        <TrackingInsights trackingType={trackingType} trackingConfig={trackingConfig} />
      </Wrapper>
    </ModalLayout>
  )
}
